// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-daterange-picker/dist/vue2-daterange-picker.css
// module id = 1212
// module chunks = 1